import React from "react";

import {
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Table,
  Row,
  Col,
} from "reactstrap";

import axios from 'axios';

import Graph from "../components/Widget/graph.jsx"
import DataCenterTable from "../components/Widget/table.jsx"

var config = {
   crossdomain: true
};

class DataCenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showGraph: "none",
      form_variable: "",
      set_variable: "",
      form_Num: "10",
      postNum: "",
      dataCenterstore:{
        AmbientHumiditySensor:{key:"AmbientHumidity",values:[],labels:[]},
        UVSensor:{key:"UV",values:[],labels:[]},
        AmbientTempSensor:{key:"AmbientTemp",values:[],labels:[]},
        BarometerMoistureSensor:{key:"BarometerMoisture",values:[],labels:[]},
        SoilTempSensor:{key:"SoilTemp",values:[],labels:[]},
        SoilMoistureSensor:{key:"SoilMoisture",values:[],labels:[]},
        BarometerTempSensor:{key:"BarometerTemp",values:[],labels:[]},
        WindSpeedSensor:{key:"WindSpeed",values:[],labels:[]},
        BarometerPressureSensor:{key:"BarometerPressure",values:[],labels:[]},
      }
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleVariableChange = this.handleVariableChange.bind(this);
    this.handlePostNumChange = this.handlePostNumChange.bind(this);
  }

  handleSubmit(event){
    event.preventDefault();
    this.setState({
      postNum: this.state.form_Num
    });
    this.pollServer();
  }

  handleVariableChange(event) {
    this.setState({
      form_variable: event.target.value
    });
  }

  handlePostNumChange(event) {
    this.setState({
      form_Num: event.target.value
    });
  }

  dateParser = (timestamp) => {
      return timestamp.split(' ')[1].slice(0,8);
  }


  pollServer(){
    // console.log("pollServer");
      axios.post(`http://localhost:8080/data`,{
          "token":localStorage.getItem('token'),
          "type":"TEST",
          "data":[{
              "RANGE":{
                  "last":this.state.form_Num
              }
          }]
      },config)
      .then(res => {
          var postreturns= res.data.data;

          console.log(postreturns)

          var AmbientHumiditySensor ={
            key:"AmbientHumidity" ,
            raw: postreturns.AmbientHumidity,
            values: postreturns.AmbientHumidity.map(val => { return Number(val.value)}).reverse(),
            labels: postreturns.AmbientHumidity.map(val => { return this.dateParser(val.timestamp)}).reverse(),

          }
          var UVSensor ={
            key:"UV" ,
            raw: postreturns.UV,
            values: postreturns.UV.map(val => { return Number(val.value)}).reverse(),
            labels: postreturns.UV.map(val => { return this.dateParser(val.timestamp)}).reverse(),

          }
          var AmbientTempSensor ={
            key:"AmbientTemp" ,
            raw: postreturns.AmbientTemp,
            values: postreturns.AmbientTemp.map(val => { return Number(val.value)}).reverse(),
            labels: postreturns.AmbientTemp.map(val => { return this.dateParser(val.timestamp)}).reverse(),

          }
          var BarometerMoistureSensor ={
            key:"BarometerMoisture" ,
            raw: postreturns.BarometerMoisture,
            values: postreturns.BarometerMoisture.map(val => { return Number(val.value)}).reverse(),
            labels: postreturns.BarometerMoisture.map(val => { return this.dateParser(val.timestamp)}).reverse(),

          }
          var SoilTempSensor ={
            key:"SoilTemp" ,
            raw: postreturns.SoilTemp,
            values: postreturns.SoilTemp.map(val => { return Number(val.value)}).reverse(),
            labels: postreturns.SoilTemp.map(val => { return this.dateParser(val.timestamp)}).reverse(),

          }
          var SoilMoistureSensor ={
            key:"SoilMoisture" ,
            raw: postreturns.SoilMoisture,
            values: postreturns.SoilMoisture.map(val => { return Number(val.value)}).reverse(),
            labels: postreturns.SoilMoisture.map(val => { return this.dateParser(val.timestamp)}).reverse(),

          }
          var BarometerTempSensor ={
            key:"BarometerTemp" ,
            raw: postreturns.BarometerTemp,
            values: postreturns.BarometerTemp.map(val => { return Number(val.value)}).reverse(),
            labels: postreturns.BarometerTemp.map(val => { return this.dateParser(val.timestamp)}).reverse(),

          }
          var WindSpeedSensor ={
            key:"WindSpeed" ,
            raw: postreturns.WindSpeed,
            values: postreturns.WindSpeed.map(val => { return Number(val.value)}).reverse(),
            labels: postreturns.WindSpeed.map(val => { return this.dateParser(val.timestamp)}).reverse(),

          }
          var BarometerPressureSensor ={
            key:"BarometerPressure" ,
            raw: postreturns.BarometerPressure,
            values: postreturns.BarometerPressure.map(val => { return Number(val.value)}).reverse(),
            labels: postreturns.BarometerPressure.map(val => { return this.dateParser(val.timestamp)}).reverse(),

          }

          this.setState({
              dataCenterstore:{
                AmbientHumiditySensor: AmbientHumiditySensor,
                UVSensor: UVSensor,
                AmbientTempSensor: AmbientTempSensor,
                BarometerMoistureSensor: BarometerMoistureSensor,
                SoilTempSensor: SoilTempSensor,
                SoilMoistureSensor: SoilMoistureSensor,
                BarometerTempSensor: BarometerTempSensor,
                WindSpeedSensor: WindSpeedSensor,
                BarometerPressureSensor: BarometerPressureSensor
              }
          });
          if (!!this.state.form_variable ){
            this.setState({
              showGraph: "block",
              set_variable: this.state.form_variable,
            });
          }else{
            this.setState({
              showGraph: "none",
            })
          }
      })
  }

  componentDidMount(){

    this.pollServer()

  }


  render() {

    const graph = (
      <div style={{display:this.state.showGraph}}>
        <Card>
          <CardBody>
            <Graph store={this.state.dataCenterstore} variable={this.state.set_variable} reload={false} num={this.state.postNum}/>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <Table responsive>
                <thead>
                    <tr>
                        <th className="text-center">#</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                  {<DataCenterTable store={this.state.dataCenterstore} variable={this.state.set_variable}/>}
                </tbody>
            </Table>
          </CardBody>
        </Card>
        <Row>
          <Col md={{ size: 2, offset: 5 }}>
            <Button color="green">Export Data</Button>
          </Col>
        </Row>
      </div>
    )
    return (
      <>
      <div className="content">
        <Card>
          <CardBody>
            <form onSubmit={this.handleSubmit}>
              <div className="form-row">
                <Col lg="3">
                  <Label for="exampleSelect1">Hub ID</Label>
                    <Input type="select" name="select" id="exampleSelect1">
                      <option value={""}>Select...</option>
                      <option>Demo Hub</option>
                    </Input>
                  </Col>
                  <Col lg="3">
                    <Label for="exampleSelect1">Node ID</Label>
                      <Input type="select" name="select" id="exampleSelect1">
                        <option value={""}>Select...</option>
                        <option>Demo Node</option>
                      </Input>
                  </Col>
                  <Col lg="3">
                    <Label for="exampleSelect1">Variable</Label>
                      <Input type="select" name="select" id="exampleSelect1" onChange={this.handleVariableChange}>
                        <option value={""}>Select...</option>
                        <option>AmbientHumidity</option>
                        <option>UV</option>
                        <option>AmbientTemp</option>
                        <option>BarometerMoisture</option>
                        <option>SoilTemp</option>
                        <option>SoilMoisture</option>
                        <option>BarometerTemp</option>
                        <option>WindSpeed</option>
                        <option>BarometerPressure</option>
                      </Input>
                  </Col>
                  <Col lg="3">
                    <Label for="exampleSelect1">Number of Data Points</Label>
                      <Input type="select" name="select" id="exampleSelect1" onChange={this.handlePostNumChange}>
                        <option>10</option>
                        <option>20</option>
                        <option>30</option>
                        <option>40</option>
                        <option>50</option>
                      </Input>
                  </Col>
                  {/*<Col lg="3">
                    <Label for="exampleSelect1">Start Date</Label>
                      <Input type="date" name="select" id="exampleSelect1"></Input>
                  </Col>
                  <Col lg="3">
                    <Label for="exampleSelect1">Start Time</Label>
                      <Input type="time" name="select" id="exampleSelect1"></Input>
                  </Col>
                  <Col lg="3">
                    <Label for="exampleSelect1">End Date</Label>
                      <Input type="date" name="select" id="exampleSelect1"></Input>
                  </Col>
                  <Col lg="3">
                    <Label for="exampleSelect1">End Time</Label>
                      <Input type="time" name="select" id="exampleSelect1"></Input>
                  </Col>*/}
                </div>
                <div className="form-row">
                  <Col md={{ size: 2, offset: 5 }}>
                    <Input type="submit" value="Generate Graph" name="Submit"/>
                  </Col>
                </div>
            </form>
          </CardBody>
        </Card>

        {graph}


      </div>
      </>


    );
  }
}

export default DataCenter;
